// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1My6o","selected":"styles_selected__9fqkQ"};